// DUCAT's support-ticket message, supplied and verified by the product owner.
export const SUPPORT_TICKET_URL = 'https://discord.com/channels/1220803043105443981/1384876051804459018/1560526166945824779';
export const SUPPORT_TICKET_LABEL = 'Open a support ticket';
